export default "__VITE_ASSET__D9Qr8XwB__"